import {SvgIcon, Typography} from '@mui/material';
import {styled} from '@mui/system';

import zoomPalette from 'zoomPalette';

export const AccountRow = styled('div')(({theme}) => ({
  'display': 'flex',
  'alignItems': 'center',
  // 'borderBottom': `1px solid ${theme.palette.common.swatch['30']}`,
  'borderRadius': '8px',
  'padding': '2px 12px',
  'position': 'relative',
  '.makePrimaryIcon': {
    color: theme.palette.common.swatch['50'],
    visibility: 'hidden',
  },
  '.hoverAction': {
    visibility: 'hidden',
  },
  '&:hover, &:focus-within': {
    'background': theme.palette.common.swatch['10'], // 'rgb(245, 245, 245)',
    'cursor': 'pointer',
    '.makePrimaryIcon': {
      visibility: 'visible',
    },
    '.hoverAction': {
      visibility: 'visible',
    },
  },
}));

export const ResolveAccountRow = styled('div')(({theme}) => ({
  'display': 'flex',
  'alignItems': 'center',
  'borderRadius': '8px',
  'padding': '2px 12px',
  'position': 'relative',
}));

export const ActionsArea = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  right: '20px',
  gap: '10px',
}));

export const TypographyTitle = styled(Typography)(({theme}) => ({
  fontWeight: 600,
  fontSize: '16px',
  color: zoomPalette.gray['90'],
}));

export const TypographyDesc = styled(Typography)(({theme}) => ({
  color: zoomPalette.gray['60'],
  fontSize: '14px',
  fontWeight: 400,
}));

export const TypographySub = styled(Typography)(({theme}) => ({
  color: zoomPalette.gray['60'],
  fontSize: '12px',
  fontWeight: 400,
}));

export const RowNameAndService = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  color: zoomPalette.gray['90'],
  fontWeight: 450,
}));

export const RowEmailAdress = styled(Typography)(({theme}) => ({
  fontSize: '12px',
  color: '#222230',
}));

export const AddAccountTips = styled(Typography)(({theme}) => ({
  fontSize: '12px',
  color: zoomPalette.gray['60'],
  marginLeft: '20px',
  fontWeight: 450,
}));

export const TextBtn = styled('span')(({theme}) => ({
  fontWeight: 450,
  fontSize: '14px',
  color: zoomPalette.blue['60'],
  cursor: 'pointer',
}));

export const StatusText = styled('span')(({theme}) => ({
  fontWeight: 450,
  fontSize: '14px',
  color: zoomPalette.gray['60'],
}));

export const SmallIcon = styled(SvgIcon)(({theme}) => ({
  width: '16px',
  height: '16px',
}));
